if (!customElements.get('countdown-global')) {
class CountdownGlobal extends HTMLElement {
    constructor() {
        super();
        this.countdownTimer = this.querySelector('.countdown-timer');
        this.countdownBlock = this.closest(".countdownBlock");
        this.countdownInterval;
        if (!this.countdownTimer) return;
        this.endDate = new Date(this.countdownTimer.dataset.endDate).getTime();
        this.updateCountdown = this.updateCountdown.bind(this);
        this.updateCountdown();
        this.countdownInterval = setInterval(this.updateCountdown, 1000);
    }
     getBeijingTime() {
        const now = new Date();
        const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
        const beijingTime = new Date(utc + (3600000 * 8));
        return beijingTime;
    }
    updateCountdown() {
        //const now = new Date().getTime();
        const now = this.getBeijingTime();
        const distance = this.endDate - now;
        if (distance < 0) {
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }
            this.countdownTimer.style.display = 'none';
            this.countdownBlock?this.countdownBlock.style.display = 'none':'';
            return;
        }
        this.countdownTimer.style.display = window.innerWidth < 768 ? 'flex' : 'flex';
        // Calculate time units
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        this.updateCountdownItem('days', days)
        this.updateCountdownItem('hours', hours)
        this.updateCountdownItem('minutes', minutes)
        this.updateCountdownItem('seconds', seconds)
    }
    updateCountdownItem(type, value) {
        const container = this.countdownTimer.querySelector(`[data-type="${type}"]`);
        if (!container) return;
        const formattedValue = String(value).padStart(2, '0');
        container.textContent = formattedValue;
    }
}
customElements.define('countdown-global', CountdownGlobal);
}